import CvCategoriesPage from "../features/cv-processor/CvCategoriesPage";

export default function CvCategoriesRoute() {
  return <CvCategoriesPage />;
}
